import getBackendUrl from './getBackendURL';

const url = getBackendUrl()+'services/shippingInfo';

async function getCountryShippingData(country: string) {
    const endpoint = `${url}/${country}`
    const response = await fetch(endpoint, { method: 'GET' })
    const result = await response.json()
    return result;
}

export default getCountryShippingData;